import { Box, Heading, Tag } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export interface IDetailsProps {
	size?: 'sm' | 'md';
	image?: React.ReactNode;
	title: string;
	isNew?: boolean;
	isOpen?: boolean;
}

export default function Details(props: PropsWithChildren<IDetailsProps>) {
	const size = props.size ?? 'md';

	return (
		<Box
			borderColor="gray.200"
			borderWidth={1}
			as="details"
			open={props.isOpen}
			mb={1}
			bg="white"
			borderRadius="md"
			__css={{
				// Aplicar estilos cuando details NO está abierto
				'&:not([open]) > summary': {
					borderBottomWidth: 0, // Eliminar el borde del summary cuando details está cerrado
				},
				// Aplicar estilos cuando details está abierto
				'&[open] > summary': {
					borderBottomRadius: 0,
					borderBottomWidth: '1px',
					borderBottomColor: 'gray.100',
				},
			}}
		>
			<Box
				as="summary"
				display="flex"
				alignItems="center"
				cursor="pointer"
				p={size === 'md' ? 4 : 2}
				_hover={{
					background: 'gray.100',
				}}
				borderRadius="md"
			>
				{props.image}
				<Heading ml={2} size={size} fontWeight="600">
					{props.title}
				</Heading>
				{props.isNew ? (
					<Tag ml="auto" colorScheme="green">
						New
					</Tag>
				) : null}
			</Box>
			<Box p={4}>{props.children}</Box>
		</Box>
	);
}
